class EventBus {
  constructor() {
    this.events = {};
  }

  $on(type, callback, scope, ...args) {
    if (typeof this.events[type] === "undefined") {
      this.events[type] = [];
    }
    this.events[type].push({ scope, callback, args });
  }

  $off(type, callback, scope) {
    if (typeof this.events[type] === "undefined") {
      return;
    }

    const filterFn = event =>
      event.scope !== scope || event.callback !== callback;
    this.events[type] = this.events[type].filter(filterFn);
  }

  $has(type, callback, scope) {
    if (typeof this.events[type] === "undefined") {
      return false;
    }

    let numOfCallbacks = this.events[type].length;
    if (callback === undefined && scope === undefined) {
      return numOfCallbacks > 0;
    }

    const conditionFn = event => {
      const scopeIsSame = scope ? event.scope === scope : true;
      const callbackIsSame = event.callback === callback;

      if (scopeIsSame && callbackIsSame) {
        return true;
      }
    };
    return this.events[type].some(conditionFn);
  }

  $emit(type, target, ...args) {
    if (typeof this.events[type] === "undefined") {
      return;
    }

    let bag = { type, target };

    const events = this.events[type].slice();

    for (const event of events) {
      if (event && event.callback) {
        event.callback.apply(event.scope, [bag, ...args, ...event.args]);
      }
    }
  }
}

export default new EventBus();
